import { Stack, StackProps } from "@chakra-ui/react";

export interface CardContentProps extends StackProps {}

export const CardContent: React.FC<CardContentProps> = ({
  children,
  ...props
}) => {
  return (
    <Stack
      p="24px 24px 0px"
      sx={{
        "&:last-child": {
          paddingBottom: "24px",
        },
      }}
      {...props}
    >
      {children}
    </Stack>
  );
};
